import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';

import { FETCH_OFFER_PDF_REQUEST } from '../actionTypes';

/**
 * @typedef {{
 *  ui: {
 *    offers: {
 *      print: {
 *        isPrinting: boolean,
 *      }
 *    }
 *  }
 * }} ConfiguratorState
 */

export default combineReducers({
  ui: combineReducers({
    offers: combineReducers({
      print: combineReducers({
        isPrinting: loading(FETCH_OFFER_PDF_REQUEST)
      })
    })
  })
});
